import React from 'react';
import ServicePage from './ServicePage';
export default function ProjectManagementMiami() {
  return <ServicePage slug="project-management-miami" />;
}
